exports.MESSAGES_PAGE_SIZE = 100;

exports.MAX_CONTENT_WIDTH = 600;

exports.MOBILE_MAX_CONTENT_WIDTH = 400;

exports.MAIN_HEADER_HEIGHT = 64;

exports.MAIN_FOOTER_HEIGHT = 56;

exports.FOOTER_TAB_HEIGHT = 56;

exports.QUICK_SWITCH_MENU_SCHOOL_TILE_SIZE = 55;

exports.DEFAULT_SCHOOL_TILE_SIZE = 65;

exports.SCHOOL_TILE_BORDER_RADIUS = 10;

exports.DIALOG_SCHOOL_IMG_HEIGHT = 80;

exports.DEFAULT_PROFILE_IMG = process.env.DEFAULT_PROFILE_IMG;

exports.EMPTY_PROFILE_IMG = process.env.EMPTY_PROFILE_IMG;

exports.APP_HEADER_LOGO_BASE = 'https://s3.amazonaws.com/near-peer/school_logos';

exports.USER_PERMISSIONS = {
    STUDENT: 'student',
    PARENT: 'parent',
    STAFF: 'staff',
    SUPER_USER: 'superuser'
};

// Any ids between 18-98 are reserved (inclusive)
exports.USER_ROLE_IDS = {
    SUPERUSER: [1, 11, 14, 18, 19, 20, 99],
    STUDENT: [2, 5, 7, 8, 9, 10, 12, 15, 17, 21, 22, 23],
    STAFF: [3, 13, 24, 25, 26],
    PARENT: [4, 16, 27, 28, 29],
    PROSPECT: [12]
};

exports.PROSPECT_ROLE_ID = 12;

exports.STUDENT_OFFER_ROLE_IDS = [2, 8, 9, 15, 17, 21, 22, 23, 24];

exports.OFFER_CREATION_METHODS = {
    MANUAL: 'manual',
    IMAGE_UPLOAD: 'imageUpload'
};

exports.RESOURCE_CREATION_METHODS = {
    MANUAL: 'manual',
    IMAGE_UPLOAD: 'imageUpload'
};

exports.OBSERVER_ROLE_ID = 99;

exports.STUDENT_USER_ROLE_NAMES = [
    'student',
    'returningStudent',
    'newStudent',
    'studentLeader'
];

exports.USER_ROLE_GROUPS_IDS = {
    STUDENT: 1,
    STAFF: 2,
    PARENT: 3,
    ALUMNUS: 4,
    EMPLOYER: 5,
    PROSPECT: 6
};

exports.USERS_SORT_TYPE = {
    BEST_MATCH: 'best_match',
    ALPHABETICAL: 'alphabetical',
    PASSION: 'passion_match',
    CONNECTION_STATUS: 'connection_status',
    HOMETOWN: 'hometown',
    MY_CONNECTIONS: 'my_connections',
    HOUSING: 'housing',
    NEWEST: 'newest',
    RANDOM: 'random',
    DISABLED: 'disabled'
};

exports.ALL_GROUPS_SORT_TYPE = {
    BY_NAME: 'name',
    BY_DATE_UPDATED: 'date_updated'
};

exports.MESSAGES_SORT_TYPE = {
    BY_NAME: 'name',
    BY_DATE_UPDATED: 'date_updated'
};

exports.SURVEYS_SORT_TYPE = {
    BY_NAME: 'name',
    BY_DATE_UPDATED: 'date_updated'
};

exports.INTERESTS = {
    LIMIT: 200
};

// 2 hours
exports.SEARCH_REFRESH_TIME_LIMIT = 2 * 60 * 60 * 1000;

exports.ELEMENT_IDS = {
    bottomButton: 'bottomButton',
    appBottomTabs: 'appBottomTabs',
    chatTextfield: 'chatTextfield',
    scrollPortalIds: {
        top: 'scrollPortalTop',
        bottom: 'scrollPortalBottom'
    },
    scrollPortalPaddingIds: {
        top: 'scrollPortalPaddingTop',
        bottom: 'scrollPortalPaddingBottom'
    },
    scrollContainer: 'scrollContainer',
    focusIndicator: 'focusIndicator'
};

exports.DEBUG_PUSH_NOTIFICATIONS = process.env.DEBUG_PUSH_NOTIFICATIONS;

exports.DEFAULT_ROLE_GROUP_FILTERS = {
    discover: 'all',
    dms: 'all',
    groups: 'all',
    admin: 'all'
};

exports.REACTIONS = {
    ':like:': '👍',
    ':heart:': '❤️',
    ':pray:': '🙏',
    ':laugh:': '😄',
    ':joy:': '😂',
    ':wow:': '😮',
    ':hug:': '🤗'
};
